/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.12.1.0 (NJsonSchema v10.4.6.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming
export class BaseEntity {
    identifier;
    createdOn;
    modifiedOn;
    constructor() {
        this.identifier = "";
        this.createdOn = null;
        this.modifiedOn = null;
    }
}
export class LocalizedEntity extends BaseEntity {
    key;
    values;
    constructor() {
        super();
        this.key = "";
        this.values = {};
    }
}
export class AutoDictionaryOfString {
    item;
    constructor() {
        this.item = "";
    }
}
export class AppConfig extends BaseEntity {
    customerSources;
    clusters;
    customerStates;
    qualifichePianoCarriera;
    acquistaBannerUrl;
    bannerInizialeUrl;
    bannerInizialeImageUrl;
    marketingReferralImageUrl;
    localizationConfiguration;
    constructor() {
        super();
        this.customerSources = [];
        this.clusters = [];
        this.customerStates = [];
        this.qualifichePianoCarriera = [];
        this.acquistaBannerUrl = "";
        this.bannerInizialeUrl = "";
        this.bannerInizialeImageUrl = "";
        this.marketingReferralImageUrl = "";
        this.localizationConfiguration = new LocalizationConfiguration();
    }
}
export class QualificaPianoCarrieraConfig {
    name;
    daysNeeded;
    constructor() {
        this.name = "";
        this.daysNeeded = null;
    }
}
export class LocalizationConfiguration {
    defaultLanguage;
    supportedLanguages;
    enabledLanguages;
    constructor() {
        this.defaultLanguage = "";
        this.supportedLanguages = [];
        this.enabledLanguages = [];
    }
}
export class CustomerCluster extends BaseEntity {
    name;
    multipliers;
    adders;
    constructor() {
        super();
        this.name = "";
        this.multipliers = new DiscountDictionary();
        this.adders = new DiscountDictionary();
    }
}
export class DiscountDictionary {
    item;
    constructor() {
        this.item = null;
    }
}
export class NameIdentifier {
    name;
    identifier;
    constructor() {
        this.name = "";
        this.identifier = "";
    }
}
export class Customer extends BaseEntity {
    name;
    surname;
    completeName;
    agenzia;
    email;
    password;
    note;
    noteInterne;
    address;
    rating;
    avatarUrl;
    partitaIva;
    codiceDestinatario;
    pec;
    recensioneLasciata;
    telefono;
    clienteOn;
    nonPiuClienteOn;
    richiestaPlanimetriaGratuitaOn;
    source;
    importanza;
    lastConnected;
    officeIdentifier;
    resetPasswordToken;
    isAccountPadre;
    clienteParentIdentifier;
    cluster;
    lastTaskOn;
    lastContact;
    freezedOn;
    state;
    activities;
    scadenza;
    stripeId;
    allegatiInterni;
    metaData;
    preferredCulture;
    constructor() {
        super();
        this.name = "";
        this.surname = "";
        this.completeName = "";
        this.agenzia = "";
        this.email = "";
        this.password = "";
        this.note = "";
        this.noteInterne = "";
        this.address = new Address();
        this.rating = null;
        this.avatarUrl = "";
        this.partitaIva = "";
        this.codiceDestinatario = "";
        this.pec = "";
        this.recensioneLasciata = false;
        this.telefono = "";
        this.clienteOn = null;
        this.nonPiuClienteOn = null;
        this.richiestaPlanimetriaGratuitaOn = null;
        this.source = "";
        this.importanza = null;
        this.lastConnected = null;
        this.officeIdentifier = "";
        this.resetPasswordToken = "";
        this.isAccountPadre = false;
        this.clienteParentIdentifier = "";
        this.cluster = "";
        this.lastTaskOn = null;
        this.lastContact = null;
        this.freezedOn = null;
        this.state = "";
        this.activities = [];
        this.scadenza = null;
        this.stripeId = "";
        this.allegatiInterni = [];
        this.metaData = {};
        this.preferredCulture = "";
    }
}
export class Address {
    latitude;
    longitude;
    typedAddress;
    constructor() {
        this.latitude = null;
        this.longitude = null;
        this.typedAddress = "";
    }
}
export class CustomerActivity {
    postedBy;
    postedOn;
    text;
    constructor() {
        this.postedBy = new NameIdentifier();
        this.postedOn = null;
        this.text = "";
    }
}
export class Attachment2 {
    fileIdentifier;
    fileName;
    mimeType;
    publicUrl;
    storagePath;
    constructor() {
        this.fileIdentifier = "";
        this.fileName = "";
        this.mimeType = "";
        this.publicUrl = "";
        this.storagePath = "";
    }
}
export class Attachment extends Attachment2 {
    attachedOn;
    constructor() {
        super();
        this.attachedOn = null;
    }
}
export class CreditTransaction extends BaseEntity {
    price;
    credits;
    note;
    customer;
    task;
    portafoglioIdentifier;
    constructor() {
        super();
        this.price = null;
        this.credits = new CreditsDictionary();
        this.note = "";
        this.customer = new NameIdentifier();
        this.task = new NameIdentifier();
        this.portafoglioIdentifier = "";
    }
}
export class CreditsDictionary {
    item;
    constructor() {
        this.item = null;
    }
}
export class MailSent extends BaseEntity {
    mailTemplateName;
    sender;
    recipient;
    subject;
    text;
    constructor() {
        super();
        this.mailTemplateName = "";
        this.sender = "";
        this.recipient = "";
        this.subject = "";
        this.text = "";
    }
}
export class GetCustomerForTrelloFilterVm {
    name;
    officeIdentifier;
    showClienti;
    showNonClienti;
    stelleFilter;
    clusterFilter;
    state;
    sortByScadenza;
    onlyFreezed;
    constructor() {
        this.name = "";
        this.officeIdentifier = "";
        this.showClienti = false;
        this.showNonClienti = false;
        this.stelleFilter = [];
        this.clusterFilter = [];
        this.state = "";
        this.sortByScadenza = null;
        this.onlyFreezed = false;
    }
}
export class StellineStatVm {
    zeroStelle;
    unaStella;
    dueStelle;
    treStelle;
    quattroStelle;
    cinqueStelle;
    totaleClienti;
    totaleLead;
    constructor() {
        this.zeroStelle = new StellineStatRowDetailsVm();
        this.unaStella = new StellineStatRowDetailsVm();
        this.dueStelle = new StellineStatRowDetailsVm();
        this.treStelle = new StellineStatRowDetailsVm();
        this.quattroStelle = new StellineStatRowDetailsVm();
        this.cinqueStelle = new StellineStatRowDetailsVm();
        this.totaleClienti = new StellineStatRowDetailsVm();
        this.totaleLead = new StellineStatRowDetailsVm();
    }
}
export class StellineStatRowDetailsVm {
    totale;
    freezati;
    nonPiuClienti;
    regali;
    constructor() {
        this.totale = null;
        this.freezati = null;
        this.nonPiuClienti = null;
        this.regali = null;
    }
}
export class StoricoClienteVm {
    transactions;
    tasks;
    constructor() {
        this.transactions = [];
        this.tasks = [];
    }
}
export class CreditTransactionVm {
    date;
    price;
    credits;
    note;
    customer;
    task;
    constructor() {
        this.date = null;
        this.price = null;
        this.credits = new CreditsDictionary();
        this.note = "";
        this.customer = "";
        this.task = "";
    }
}
export class TaskWithModificheVm {
    taskName;
    taskDate;
    modificheHistory;
    creditPrice;
    product;
    constructor() {
        this.taskName = "";
        this.taskDate = null;
        this.modificheHistory = [];
        this.creditPrice = null;
        this.product = "";
    }
}
export class DateText {
    date;
    text;
    constructor() {
        this.date = null;
        this.text = "";
    }
}
export class NewClientiStatVm {
    clienti;
    lead;
    constructor() {
        this.clienti = null;
        this.lead = null;
    }
}
export class CustomerServiceTableVm {
    identifier;
    createdOn;
    clienteOn;
    name;
    surname;
    cluster;
    email;
    source;
    credits;
    lastTaskOn;
    lastLoginOn;
    lastContact;
    richiestaPlanimetriaGratuitaOn;
    nonPiuClienteOn;
    rating;
    constructor() {
        this.identifier = "";
        this.createdOn = null;
        this.clienteOn = null;
        this.name = "";
        this.surname = "";
        this.cluster = "";
        this.email = "";
        this.source = "";
        this.credits = new CreditsDictionary();
        this.lastTaskOn = null;
        this.lastLoginOn = null;
        this.lastContact = null;
        this.richiestaPlanimetriaGratuitaOn = null;
        this.nonPiuClienteOn = null;
        this.rating = null;
    }
}
export class CreateCustomerChildVm {
    parentIdentifier;
    name;
    surname;
    email;
    password;
    constructor() {
        this.parentIdentifier = "";
        this.name = "";
        this.surname = "";
        this.email = "";
        this.password = "";
    }
}
export class MapMarker {
    title;
    position;
    constructor() {
        this.title = "";
        this.position = new MarkerPosition();
    }
}
export class MarkerPosition {
    lat;
    lng;
    constructor() {
        this.lat = null;
        this.lng = null;
    }
}
export class AddCreditVm {
    customerIdentifier;
    credits;
    transactionPrice;
    constructor() {
        this.customerIdentifier = "";
        this.credits = new CreditsDictionary();
        this.transactionPrice = null;
    }
}
export class LoginResponse {
    userIdentifier;
    createdOn;
    token;
    name;
    surname;
    qualifica;
    role;
    email;
    firmaEmail;
    preferredCulture;
    isFreezed;
    constructor() {
        this.userIdentifier = "";
        this.createdOn = null;
        this.token = "";
        this.name = "";
        this.surname = "";
        this.qualifica = "";
        this.role = "";
        this.email = "";
        this.firmaEmail = "";
        this.preferredCulture = "";
        this.isFreezed = false;
    }
}
export class RegisterCustomerVm {
    name;
    surname;
    agenzia;
    telefono;
    email;
    password;
    constructor() {
        this.name = "";
        this.surname = "";
        this.agenzia = "";
        this.telefono = "";
        this.email = "";
        this.password = "";
    }
}
export class LoginVm {
    email;
    password;
    constructor() {
        this.email = "";
        this.password = "";
    }
}
export class PasswordResetVm {
    email;
    token;
    newPassword;
    constructor() {
        this.email = "";
        this.token = "";
        this.newPassword = "";
    }
}
export class MailTemplate extends BaseEntity {
    eventName;
    subject;
    displaySubject;
    htmlContent;
    displayHtmlContent;
    constructor() {
        super();
        this.eventName = "";
        this.subject = "";
        this.displaySubject = new LocalizedText();
        this.htmlContent = "";
        this.displayHtmlContent = new LocalizedText();
    }
}
export class LocalizedText {
    values;
    constructor() {
        this.values = {};
    }
}
export class SendEmailVm {
    email;
    fromMail;
    subject;
    htmlContent;
    mailTemplateName;
    constructor() {
        this.email = "";
        this.fromMail = "";
        this.subject = "";
        this.htmlContent = "";
        this.mailTemplateName = "";
    }
}
export class Portafoglio extends BaseEntity {
    customerIdentifier;
    credits;
    constructor() {
        super();
        this.customerIdentifier = "";
        this.credits = new CreditsDictionary();
    }
}
export class Product extends BaseEntity {
    name;
    displayName;
    price;
    description;
    displayDescription;
    imageUrl;
    clusters;
    formUrl;
    order;
    daysForDueDate;
    disponibileGestim;
    gestimFormUrl;
    postOrder;
    tabellaCompensi;
    constructor() {
        super();
        this.name = "";
        this.displayName = new LocalizedText();
        this.price = null;
        this.description = "";
        this.displayDescription = new LocalizedText();
        this.imageUrl = "";
        this.clusters = [];
        this.formUrl = "";
        this.order = null;
        this.daysForDueDate = null;
        this.disponibileGestim = false;
        this.gestimFormUrl = "";
        this.postOrder = new PostOrder();
        this.tabellaCompensi = {};
    }
}
export class PostOrder {
    usePostOrder;
    htmlContent;
    displayHtmlContent;
    upsellProducts;
    constructor() {
        this.usePostOrder = false;
        this.htmlContent = "";
        this.displayHtmlContent = new LocalizedText();
        this.upsellProducts = [];
    }
}
export class UpsellProduct {
    name;
    displayName;
    description;
    displayDescription;
    imageUrl;
    price;
    priceWithVat;
    constructor() {
        this.name = "";
        this.displayName = new LocalizedText();
        this.description = "";
        this.displayDescription = new LocalizedText();
        this.imageUrl = "";
        this.price = null;
        this.priceWithVat = null;
    }
}
export class AutoDictionaryOfAutoDictionaryOfDecimal {
    item;
    constructor() {
        this.item = {};
    }
}
export class AutoDictionaryOfDecimal {
    item;
    constructor() {
        this.item = null;
    }
}
export class BuyPostOrderVm {
    token;
    productIdentifier;
    upsellProductName;
    customerIdentifier;
    constructor() {
        this.token = "";
        this.productIdentifier = "";
        this.upsellProductName = "";
        this.customerIdentifier = "";
    }
}
export class Referral extends BaseEntity {
    name;
    surname;
    email;
    telephone;
    stato;
    referrer;
    note;
    constructor() {
        super();
        this.name = "";
        this.surname = "";
        this.email = "";
        this.telephone = "";
        this.stato = "";
        this.referrer = new NameIdentifier();
        this.note = "";
    }
}
export class RegistroAccessi extends BaseEntity {
    customer;
    constructor() {
        super();
        this.customer = new NameIdentifier();
    }
}
export class RichiestaPagamentoUser extends BaseEntity {
    user;
    nazione;
    importoLordo;
    importoNetto;
    taskList;
    sentOn;
    useRitenutaAcconto;
    datiRitenutaAcconto;
    gestitaOn;
    constructor() {
        super();
        this.user = new NameIdentifier();
        this.nazione = "";
        this.importoLordo = null;
        this.importoNetto = null;
        this.taskList = [];
        this.sentOn = null;
        this.useRitenutaAcconto = false;
        this.datiRitenutaAcconto = new DatiRitenutaAcconto();
        this.gestitaOn = null;
    }
}
export class DatiRitenutaAcconto {
    dataRitenuta;
    nomeUtente;
    luogoNascita;
    indirizzoResidenza;
    codiceFiscale;
    iban;
    intestatarioConto;
    importoLordo;
    importoRitenuta;
    importoNetto;
    constructor() {
        this.dataRitenuta = "";
        this.nomeUtente = "";
        this.luogoNascita = "";
        this.indirizzoResidenza = "";
        this.codiceFiscale = "";
        this.iban = "";
        this.intestatarioConto = "";
        this.importoLordo = "";
        this.importoRitenuta = "";
        this.importoNetto = "";
    }
}
export class PagamentoCompensiRequestVm {
    tasksList;
    user;
    useRitenutaAcconto;
    datiRitenutaAcconto;
    constructor() {
        this.tasksList = [];
        this.user = new NameIdentifier();
        this.useRitenutaAcconto = false;
        this.datiRitenutaAcconto = new DatiRitenutaAcconto();
    }
}
export class RiepilogoGiornalieroVm {
    identifier;
    date;
    createdBy;
    constructor() {
        this.identifier = "";
        this.date = null;
        this.createdBy = new NameIdentifier();
    }
}
export class RiepilogoGiornaliero extends BaseEntity {
    date;
    leadBase;
    leadExtra;
    nuoviClienti;
    assegnatiAdAssunti;
    taskAssegnati;
    taskAltri;
    taskAperti;
    modificheTask;
    rivendite;
    fatturatoNuoviClienti;
    fatturatoRivendite;
    fatturatoGiorno;
    fatturatoMese;
    createdBy;
    accessiGiornalieri;
    constructor() {
        super();
        this.date = null;
        this.leadBase = null;
        this.leadExtra = null;
        this.nuoviClienti = null;
        this.assegnatiAdAssunti = [];
        this.taskAssegnati = null;
        this.taskAltri = null;
        this.taskAperti = null;
        this.modificheTask = null;
        this.rivendite = null;
        this.fatturatoNuoviClienti = null;
        this.fatturatoRivendite = null;
        this.fatturatoGiorno = null;
        this.fatturatoMese = null;
        this.createdBy = new NameIdentifier();
        this.accessiGiornalieri = null;
    }
}
export class NameNumberPair {
    name;
    identifier;
    number;
    constructor() {
        this.name = "";
        this.identifier = "";
        this.number = null;
    }
}
export class ShopOffer extends BaseEntity {
    name;
    displayName;
    description;
    displayDescription;
    imageUrl;
    clusters;
    order;
    options;
    disabledOn;
    constructor() {
        super();
        this.name = "";
        this.displayName = new LocalizedText();
        this.description = "";
        this.displayDescription = new LocalizedText();
        this.imageUrl = "";
        this.clusters = [];
        this.order = null;
        this.options = [];
        this.disabledOn = null;
    }
}
export class ShopOfferOption {
    credits;
    name;
    displayName;
    priceBarrato;
    price;
    priceWithVat;
    constructor() {
        this.credits = new CreditsDictionary();
        this.name = "";
        this.displayName = new LocalizedText();
        this.priceBarrato = "";
        this.price = null;
        this.priceWithVat = null;
    }
}
export class BuyOfferVm {
    token;
    shopOfferIdentifier;
    optionName;
    customerIdentifier;
    constructor() {
        this.token = "";
        this.shopOfferIdentifier = "";
        this.optionName = "";
        this.customerIdentifier = "";
    }
}
export class ShopOfferGestim extends BaseEntity {
    name;
    description;
    imageUrl;
    clusters;
    order;
    options;
    constructor() {
        super();
        this.name = "";
        this.description = "";
        this.imageUrl = "";
        this.clusters = [];
        this.order = null;
        this.options = [];
    }
}
export class StripeCardDetailVm {
    cardId;
    brand;
    country;
    currency;
    expMonth;
    expYear;
    dynamicLast4;
    last4;
    holder;
    constructor() {
        this.cardId = "";
        this.brand = "";
        this.country = "";
        this.currency = "";
        this.expMonth = null;
        this.expYear = null;
        this.dynamicLast4 = "";
        this.last4 = "";
        this.holder = "";
    }
}
export class StripeSaveCardVm {
    customerIdentifier;
    paymentMethodId;
    constructor() {
        this.customerIdentifier = "";
        this.paymentMethodId = "";
    }
}
export class TaskTrelloCollaboratoriVm {
    todo;
    working;
    waiting;
    concluded;
    constructor() {
        this.todo = [];
        this.working = [];
        this.waiting = [];
        this.concluded = [];
    }
}
export class TaskTableVm {
    identifier;
    product;
    title;
    customer;
    userAssigned;
    startDate;
    dueDate;
    lastState;
    compenso;
    creditPrice;
    priorita;
    constructor() {
        this.identifier = "";
        this.product = new NameIdentifier();
        this.title = "";
        this.customer = new NameIdentifier();
        this.userAssigned = new NameIdentifierDate();
        this.startDate = null;
        this.dueDate = null;
        this.lastState = new DateText();
        this.compenso = null;
        this.creditPrice = null;
        this.priorita = false;
    }
}
export class NameIdentifierDate extends NameIdentifier {
    date;
    constructor() {
        super();
        this.date = null;
    }
}
export class TaskTrelloVm {
    groupName;
    user;
    tasks;
    constructor() {
        this.groupName = "";
        this.user = new NameIdentifier();
        this.tasks = [];
    }
}
export class TaskTableResponseVm {
    totalTasks;
    totalCrediti;
    averageCompenso;
    totalCompenso;
    data;
    constructor() {
        this.totalTasks = null;
        this.totalCrediti = null;
        this.averageCompenso = null;
        this.totalCompenso = null;
        this.data = [];
    }
}
export class GetTaskTableFilterVm {
    showConcluded;
    officeIdentifier;
    userIdentifier;
    fromDate;
    toDate;
    constructor() {
        this.showConcluded = false;
        this.officeIdentifier = "";
        this.userIdentifier = "";
        this.fromDate = null;
        this.toDate = null;
    }
}
export class Task extends BaseEntity {
    product;
    uid;
    creditPrice;
    title;
    priorita;
    deveSeguireLeFoto;
    description;
    startDate;
    dueDate;
    endDate;
    stateHistory;
    modificheHistory;
    customer;
    requestAttachments;
    officeIdentifier;
    compenso;
    metriQuadri;
    showDeliveryAttachments;
    userAssigned;
    deliveryAttachments;
    transactionIdentifier;
    gestimRequestIdentifier;
    postOrderTask;
    metaData;
    qualitaTask;
    standByTask;
    constructor() {
        super();
        this.product = new NameIdentifier();
        this.uid = null;
        this.creditPrice = null;
        this.title = "";
        this.priorita = false;
        this.deveSeguireLeFoto = false;
        this.description = "";
        this.startDate = null;
        this.dueDate = null;
        this.endDate = null;
        this.stateHistory = [];
        this.modificheHistory = [];
        this.customer = new NameIdentifier();
        this.requestAttachments = [];
        this.officeIdentifier = "";
        this.compenso = null;
        this.metriQuadri = null;
        this.showDeliveryAttachments = false;
        this.userAssigned = new NameIdentifierDate();
        this.deliveryAttachments = [];
        this.transactionIdentifier = "";
        this.gestimRequestIdentifier = "";
        this.postOrderTask = new PostOrderTask();
        this.metaData = {};
        this.qualitaTask = new QualitaTask();
        this.standByTask = new StandByTask();
    }
}
export class PostOrderTask {
    name;
    constructor() {
        this.name = "";
    }
}
export class QualitaTask {
    erroreLeggero;
    erroreGrave;
    erroreDoppio;
    erroreCliente;
    constructor() {
        this.erroreLeggero = false;
        this.erroreGrave = false;
        this.erroreDoppio = false;
        this.erroreCliente = false;
    }
}
export class StandByTask {
    planimetriaNonScalabile;
    mancanoIndicazioniDisposizione;
    mancanoDestinazioniDuso;
    planimetriaScansionataMale;
    mancaIlGiardino;
    altro;
    constructor() {
        this.planimetriaNonScalabile = false;
        this.mancanoIndicazioniDisposizione = false;
        this.mancanoDestinazioniDuso = false;
        this.planimetriaScansionataMale = false;
        this.mancaIlGiardino = false;
        this.altro = false;
    }
}
export class AssignTaskVm {
    taskIdentifier;
    userIdentifier;
    constructor() {
        this.taskIdentifier = "";
        this.userIdentifier = "";
    }
}
export class TaskVm {
    identifier;
    product;
    creditPrice;
    title;
    startDate;
    dueDate;
    endDate;
    lastState;
    deliveryAttachmentsCount;
    showDeliveryAttachments;
    constructor() {
        this.identifier = "";
        this.product = new NameIdentifier();
        this.creditPrice = null;
        this.title = "";
        this.startDate = null;
        this.dueDate = null;
        this.endDate = null;
        this.lastState = new DateText();
        this.deliveryAttachmentsCount = null;
        this.showDeliveryAttachments = false;
    }
}
export class TaskStatVm {
    prodotto;
    created;
    modificheRichieste;
    creditiUsati;
    constructor() {
        this.prodotto = "";
        this.created = null;
        this.modificheRichieste = null;
        this.creditiUsati = null;
    }
}
export class GestimRequest extends BaseEntity {
    id_richiesta;
    url_foto;
    url_planimetrie;
    title;
    constructor() {
        super();
        this.id_richiesta = "";
        this.url_foto = [];
        this.url_planimetrie = [];
        this.title = "";
    }
}
export class ExportTaskFilterVm {
    clienteParentIdentifier;
    customerIdentifier;
    dateFrom;
    dateTo;
    constructor() {
        this.clienteParentIdentifier = "";
        this.customerIdentifier = "";
        this.dateFrom = null;
        this.dateTo = null;
    }
}
export class RiepilogoStandByTaskVm {
    planimetriaNonScalabile;
    mancanoIndicazioniDisposizione;
    mancanoDestinazioniDuso;
    planimetriaScansionataMale;
    mancaIlGiardino;
    altro;
    constructor() {
        this.planimetriaNonScalabile = null;
        this.mancanoIndicazioniDisposizione = null;
        this.mancanoDestinazioniDuso = null;
        this.planimetriaScansionataMale = null;
        this.mancaIlGiardino = null;
        this.altro = null;
    }
}
export class RiepilogoErroriArchitettiVm {
    architetto;
    totaleTask;
    totaleHaSeguitoLeFoto;
    perfette;
    qualitaTaskCounter;
    totaleCrediti;
    totaleCompenso;
    task0Metri;
    task50Metri;
    task50100Metri;
    task100150Metri;
    task150200Metri;
    task200Metri;
    constructor() {
        this.architetto = new NameIdentifier();
        this.totaleTask = null;
        this.totaleHaSeguitoLeFoto = null;
        this.perfette = null;
        this.qualitaTaskCounter = new QualitaTaskCounter();
        this.totaleCrediti = null;
        this.totaleCompenso = null;
        this.task0Metri = null;
        this.task50Metri = null;
        this.task50100Metri = null;
        this.task100150Metri = null;
        this.task150200Metri = null;
        this.task200Metri = null;
    }
}
export class QualitaTaskCounter {
    erroreLeggero;
    erroreGrave;
    erroreDoppio;
    erroreCliente;
    constructor() {
        this.erroreLeggero = null;
        this.erroreGrave = null;
        this.erroreDoppio = null;
        this.erroreCliente = null;
    }
}
export class User extends BaseEntity {
    name;
    email;
    password;
    telephone;
    role;
    resetPasswordToken;
    order;
    firmaEmail;
    isAssunto;
    isAddettoRivendite;
    qualifica;
    storicoQualifiche;
    disabledOn;
    datiPerRitenuta;
    constructor() {
        super();
        this.name = "";
        this.email = "";
        this.password = "";
        this.telephone = "";
        this.role = "";
        this.resetPasswordToken = "";
        this.order = null;
        this.firmaEmail = "";
        this.isAssunto = false;
        this.isAddettoRivendite = false;
        this.qualifica = "";
        this.storicoQualifiche = [];
        this.disabledOn = null;
        this.datiPerRitenuta = new DatiPerRitenuta();
    }
}
export class DatiPerRitenuta {
    nome;
    cognome;
    codiceFiscale;
    iban;
    intestazioneConto;
    constructor() {
        this.nome = "";
        this.cognome = "";
        this.codiceFiscale = "";
        this.iban = "";
        this.intestazioneConto = "";
    }
}
export class NameIdentifierQualifica extends NameIdentifier {
    qualifica;
    constructor() {
        super();
        this.qualifica = "";
    }
}
export class SaveUsersOrderVm {
    user;
    order;
    constructor() {
        this.user = new NameIdentifier();
        this.order = null;
    }
}
export class SpesaCollaboratoriVm {
    name;
    amount;
    constructor() {
        this.name = "";
        this.amount = null;
    }
}
